import React from 'react';
import PropTypes from 'prop-types';
import './CreditSuccess.scss';

const CreditSuccess = props => (
  <div className="row credit ">
    <div className="col-sm-12">
      Nice! You&#39;ll get a ${props.credit} credit towards your
      first bill to say thanks for joining Skinny Broadband.
    </div>
  </div>
);

CreditSuccess.propTypes = {
  credit: PropTypes.number
};

export default CreditSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/creditsuccess/CreditSuccess.js
 **/